function sortByName(arr) {
  if (!arr || !arr.length) return arr;
  return [...arr].sort((a, b) => {
    const nameA = (a.name || a || "").toString().toLowerCase();
    const nameB = (b.name || b || "").toString().toLowerCase();
    return nameA.localeCompare(nameB, "de");
  });
}

export default {
  data: state => {
    return {
      books: sortByName(state.books),
      bookPackages: sortByName(state.bookPackages),
      chapters: sortByName(state.chapters),
      competenceModules: sortByName(state.competenceModules),
      schoolSubjects: sortByName(state.schoolSubjects),
      schoolTypes: sortByName(state.schoolTypes),
      skills: sortByName(state.skills),
      tasks: state.tasks,
      taskTypes: sortByName(state.taskTypes),
      topics: sortByName(state.topics),
      filter: sortByName(state.filter),
      contentTypes: sortByName(state.contentTypes)
    };
  },
  names: state => {
    return state.names;
  },
  meta: state => {
    return state.meta;
  },
  basicFilter: state => {
    return state.basicFilter;
  },
  currententities: state => {
    return state.current;
  },
  allSkills: state => {
    return sortByName(state.skills);
  },
  allChapters: state => {
    return sortByName(state.chapters);
  },
  allPackages: state => {
    return sortByName(state.bookPackages);
  },
  allTopics: state => {
    return sortByName(state.topics);
  },
  filteredTasks: state => {
    return state.tasks;
  },
  deploymentResults: state => {
    return state.deploymentResults;
  },
  hasMoreTasks: state => {
    return state.hasMoreTasks;
  },
  loadingMoreTasks: state => {
    return state.loadingMoreTasks;
  }
};
